import { render, staticRenderFns } from "./RecordingTranscriptModal.vue?vue&type=template&id=cbdb3c64&"
import script from "./RecordingTranscriptModal.vue?vue&type=script&lang=js&"
export * from "./RecordingTranscriptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports